import React from "react";
import { GoalColumnIcon } from "./goal-column-icons";
import { GoalToggleButton } from "./goal-toggle-button";
import { MetricBar } from "./metric-bar";

interface GoalTileContent {
    icon: GoalColumnIcon;
    label: string;
    barColor: string;
    actual: number;
    target: number;
    frac: number;
    footer: React.ReactNode;
}

const GoalTileBody: React.FC<GoalTileContent> = ({
    icon: Icon,
    label,
    barColor,
    actual,
    target,
    frac,
    footer,
}) => (
    <>
        <div className="flex items-center gap-1.5">
            <Icon aria-hidden="true" className="h-4 w-4 flex-shrink-0 text-gray-500" />
            <span className="truncate text-xs font-semibold text-zinc-800">{label}</span>
        </div>
        <div className="mt-1.5 flex items-baseline gap-1">
            <span className="text-xl font-bold leading-none tabular-nums text-zinc-950">
                {actual}
            </span>
            <span className="text-xs text-gray-500">/ {target}</span>
        </div>
        <div className="mt-2">
            <MetricBar
                actual={actual}
                target={target}
                bar={barColor}
                frac={frac}
                height="h-1.5"
            />
        </div>
        <div className="mt-1.5 text-[11px] text-gray-500">{footer}</div>
    </>
);

interface GoalFilterTileProps extends GoalTileContent {
    selected: boolean;
    onToggle: () => void;
}

export const GoalFilterTile: React.FC<GoalFilterTileProps> = ({
    selected,
    onToggle,
    ...content
}) => (
    <GoalToggleButton
        selected={selected}
        onToggle={onToggle}
        className="min-w-0 rounded-lg px-3 py-2.5">
        <GoalTileBody {...content} />
    </GoalToggleButton>
);
